import { useSelector } from 'react-redux'
import styles from './CustomDomainModal.module.css'
import { Modal } from 'react-bootstrap'
import { Formik } from 'formik'
import StepRenderer from './components/StepRenderer'
import { ProgressIndicator } from './components/SharedComponents'
import CustomModal from 'components/CustomModal/CustomModal'
import { CustomDomainProvider } from './context/CustomDomainProvider'
import { useCustomDomainModal } from './hooks/useCustomDomainModal'
import { getCustomDomainSchema } from './hooks/domainValidation'

const CustomDomainModal = (props) => {
  const { show, onClose, domains = [], modalData } = props

  const { activeStep, initialValues, handleNext, handleBack, handleClose, setActiveStep } = useCustomDomainModal({
    show,
    onClose,
    modalData
  })

  const { userProfile } = useSelector((state) => state.manage)

  const validationSchema = getCustomDomainSchema(domains)

  return (
    <CustomDomainProvider>
      <CustomModal
        aria-labelledby="contained-modal-title-vcenter"
        show={show}
        centered
        onHide={handleClose}
        backdrop="static"
        enforceFocus={false}
      >
        <Modal.Header className={styles.header} closeButton>
          <div className={styles.progress}>
            <ProgressIndicator steps={5} activeIndex={activeStep} />
          </div>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <Formik
            validateOnMount
            validateOnChange
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true)
              setSubmitting(false)
            }}
          >
            {(formik) => (
              <StepRenderer
                activeStep={activeStep}
                formik={formik}
                handlers={{
                  handleNext,
                  handleBack,
                  handleClose,
                  setActiveStep,
                  handleCheckEntri: props.handleCheckEntri
                }}
                props={{
                  ...props,
                  userProfile
                }}
              />
            )}
          </Formik>
        </Modal.Body>
      </CustomModal>
    </CustomDomainProvider>
  )
}

export default CustomDomainModal
